<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="障害/メンテナンス詳細情報"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mt-2">
              <v-col>
                <app-label-group
                  label="障害情報"
                  :value="$filter.emptyTo(failureMaintenanceItem.failure, '-')"
                  class="content"
                ></app-label-group>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col>
                <app-label-group
                  label="メンテナンス情報"
                  :value="
                    $filter.emptyTo(failureMaintenanceItem.maintenance, '-')
                  "
                  class="content"
                ></app-label-group>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-2">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CommonFailure } from "@/apis/InformationApi";

export default defineComponent({
  name: "FailureMaintenanceReference",
  props: {
    /** 選択行の障害/メンテナンス情報 */
    failureMaintenanceItem: {
      type: Object as PropType<CommonFailure>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.content {
  white-space: pre-line;
  word-break: break-word;
}
</style>
